import { StatesModule } from '@uirouter/angular';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { TagService } from '@fi-app/tag/tag.service';
import { TagEditComponent } from '@fi-app/tag/tag-edit/tag-edit.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { TagViewComponent } from '@fi-app/tag/tag-view/tag-view.component';
import { TagModel } from '@fi-shared/models';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { TagListComponent } from '@fi-app/tag/tag-list/tag-list.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export function TagListPageTitle(PageTitleService: PageTitleService) {
    PageTitleService.setTitleByItem(ObjectTypes.Tag);
}

const TagListState = {
    name: FiStateNames.Tag.List,
    url: '/?:filterType&:sortColumn&:sortDirection&:offset',
    component: TagListComponent,
    reloadOnSearch: false,
    resolve: [
        {
            token: 'pageTitle',
            deps: [PageTitleService],
            resolveFn: TagListPageTitle,
        },
    ],
};

export function TagAddTag(TagService: TagService) {
    return TagService.GetTag(0);
}

export function TagAddPageTitle(ccmPageTitle: PageTitleService, tag: TagModel) {
    ccmPageTitle.setTitleByItem(tag);
}

export function TagAddAllTags(TagService: TagService) {
    return TagService.getAllLightWeightTags();
}
const TagAddState = {
    name: FiStateNames.Tag.Add,
    url: '/Add',
    views: {
        '@': {
            component: TagEditComponent,
        },
    },
    resolve: [
        {
            token: 'tag',
            deps: [TagService],
            resolveFn: TagAddTag,
        },
        {
            token: 'pageTitle',
            deps: [PageTitleService, 'tag'],
            resolveFn: TagAddPageTitle,
        },
        {
            token: 'allTags',
            deps: [TagService],
            resolveFn: TagAddAllTags,
        },
    ],
};

export function TagViewTag(TagService: TagService, stateService: FiStateService, transition) {
    return TagService.GetTag(~~stateService.getParams(transition).Id);
}

export function TagViewPageTitle(ccmPageTitle: PageTitleService, tag: TagModel) {
    ccmPageTitle.setTitleByItem(tag);
}
export const TagViewState = {
    name: FiStateNames.Tag.View,
    url: '/:Id',
    views: {
        '@': {
            component: TagViewComponent,
        },
    },
    resolve: [
        {
            token: 'tag',
            deps: [TagService, FiStateService, '$transition$'],
            resolveFn: TagViewTag,
        },
        {
            token: 'pageTitle',
            deps: [PageTitleService, 'tag'],
            resolveFn: TagViewPageTitle,
        },
    ],
};

export function TagEditTag(TagService: TagService, stateService: FiStateService, transition) {
    return TagService.GetTag(~~stateService.getParams(transition).Id);
}

export function TagEditPageTitle(ccmPageTitle: PageTitleService, tag: TagModel) {
    ccmPageTitle.setTitleByItem(tag);
}

export function TagEditAllTags(TagService: TagService) {
    return TagService.getAllLightWeightTags();
}
const TagEditState = {
    name: FiStateNames.Tag.Edit,
    url: '/:Id/Edit',
    views: {
        '@': {
            component: TagEditComponent,
        },
    },
    resolve: [
        {
            token: 'tag',
            deps: [TagService, FiStateService, '$transition$'],
            resolveFn: TagEditTag,
        },
        {
            token: 'pageTitle',
            deps: [PageTitleService, 'tag'],
            resolveFn: TagEditPageTitle,
        },
        {
            token: 'allTags',
            deps: [TagService],
            resolveFn: TagEditAllTags,
        },
    ],
};

export const TagStates: StatesModule = {
    states: [
        {
            name: FiStateNames.Tag._name,
            url: '/Tag',
            parent: FiStateNames.GlobalSettings,
            component: FiAbstractStateComponent,
        },
        TagListState,
        TagAddState,
        TagViewState,
        TagEditState,
    ],
};

export function registerTagStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Tag.List, FiStateNames.Tag.View, FiStateNames.Tag.Edit], {
        SettingType: [ApplicationSettingsType.Tag],
        AccessType: AccessRightType.Admin,
    });
}
